import { RtmRuleBuilderFormValues } from 'app/modules/detectionModels/components/RtmRuleBuilderForm/models';
import { DEFAULT_DROPDOWN_BUILDER_FORM_VALUES } from 'app/modules/detectionModels/constants';

export const DEFAULT_RTM_FORM_VALUES: RtmRuleBuilderFormValues = {
  eventSubTypes: [],
  dropdownBuilderFormValues: DEFAULT_DROPDOWN_BUILDER_FORM_VALUES,
  objectToFlag: 'TXN_EVENT',
};
